import {Heading, Img} from "./..";
import React from "react";

interface Props {
    className?: string;
    icon?: string;
    tabsNumber?: string;
    title?: string;
    description?: string;
}

export default function OurPlusTabs({...props}) {
    return (
        <div
            {...props}
            className={`${props.className} flex flex-col lg:gap-[60px] gap-12 p-10 sm:p-6 md:p-6 bg-[#ededed] lg:rounded-[48px] rounded-[32px]`}
            >
            <Img
                src={props.icon}
                alt="icon"
                className="object-contain w-[64px] h-[64px]"/>
            <div className="fflex flex-col items-start justify-center gap-6 self-stretch">
                <Heading
                    size="desktop_body_l"
                    className="text-[#1B1F3BA6] font-medium">
                    {props.tabsNumber}
                </Heading>
                <div className="flex flex-col items-start gap-4 self-stretch mt-6">
                    <Heading
                        size="desktop_heading_6"
                        className="text-[#191C30E5] uppercase font-medium leading-[120%]">
                        {props.title}
                    </Heading>
                    <Heading
                        size="desktop_body_l"
                        className="text-[#191C30E5] font-medium md:hidden sm:hidden">
                        {props.description}
                    </Heading>
                    <Heading
                        size="desktop_body_m"
                        className="text-[#191C30E5] font-medium lg:hidden">
                        {props.description}
                    </Heading>
                </div>
            </div>
        </div>
    )
}